function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { LandingDescription } from './LandingDescription';
import { SimpleGrid, tempo, Image } from '@tempo/core';
import { useLandingPageScales } from './LandingPage';
export const useMapContentPositionToProps = (contentPosition, contentContained)=>{
    const { containerGutters, sectionContentSpacing } = useLandingPageScales();
    const parentGrid = {
        alignItems: 'center',
        justifyItems: 'center',
        gap: sectionContentSpacing,
        px: contentContained ? containerGutters : undefined,
        w: '100%'
    };
    const { base, sm } = containerGutters;
    const mobileContainerGutters = {
        base,
        sm
    };
    switch(contentPosition){
        case 'left':
            {
                const paddingStyles = !contentContained ? {
                    ps: _object_spread_props(_object_spread({}, mobileContainerGutters), {
                        md: 'initial'
                    }),
                    pe: containerGutters
                } : {};
                return {
                    parentGrid,
                    description: _object_spread({
                        textAlign: {
                            base: 'center',
                            md: 'start'
                        },
                        alignItems: {
                            base: 'center',
                            md: 'flex-start'
                        }
                    }, paddingStyles)
                };
            }
        case 'right':
            {
                const paddingStyles = !contentContained ? {
                    pe: _object_spread_props(_object_spread({}, mobileContainerGutters), {
                        md: 'initial'
                    }),
                    ps: containerGutters
                } : {};
                return {
                    parentGrid,
                    description: _object_spread({
                        textAlign: {
                            base: 'center',
                            md: 'start'
                        },
                        alignItems: {
                            base: 'center',
                            md: 'flex-start'
                        }
                    }, paddingStyles)
                };
            }
        case 'bottom':
            {
                return {
                    parentGrid,
                    description: {
                        textAlign: 'center',
                        alignItems: 'center',
                        px: !contentContained ? containerGutters : undefined
                    }
                };
            }
    }
};
export const LandingSection = (_param)=>{
    var { contentPosition = 'bottom', description, cta, isContained = false, children, bgImg = null } = _param, props = _object_without_properties(_param, [
        "contentPosition",
        "description",
        "cta",
        "isContained",
        "children",
        "bgImg"
    ]);
    const { parentGrid, description: descriptionProps } = useMapContentPositionToProps(contentPosition, isContained);
    const zIndexProps = bgImg ? {
        zIndex: '1'
    } : undefined;
    const desc = description ? /*#__PURE__*/ _jsxs(LandingDescription, _object_spread_props(_object_spread({}, zIndexProps, descriptionProps), {
        order: {
            base: 1,
            md: 'initial'
        },
        children: [
            description,
            contentPosition !== 'bottom' && cta && /*#__PURE__*/ React.isValidElement(cta) && /*#__PURE__*/ React.cloneElement(cta, {
                display: {
                    base: 'none',
                    md: 'block'
                }
            })
        ]
    })) : null;
    const content = React.Children.map(children, (child)=>{
        if (/*#__PURE__*/ React.isValidElement(child)) {
            return /*#__PURE__*/ React.cloneElement(child, _object_spread({
                order: {
                    base: 2,
                    md: 'initial'
                }
            }, zIndexProps));
        }
        return child;
    });
    return /*#__PURE__*/ _jsxs(SimpleGrid, _object_spread_props(_object_spread({
        columns: contentPosition === 'bottom' ? 1 : {
            base: 1,
            md: 2
        }
    }, parentGrid, props), {
        children: [
            contentPosition === 'left' ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    content,
                    desc
                ]
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    desc,
                    content
                ]
            }),
            cta && /*#__PURE__*/ React.isValidElement(cta) && /*#__PURE__*/ React.cloneElement(cta, _object_spread_props(_object_spread({}, contentPosition !== 'bottom' && {
                display: {
                    base: 'block',
                    md: 'none'
                }
            }), {
                order: 3
            })),
            bgImg
        ]
    }));
};
export const LandingIllustrationImage = tempo(Image, {
    baseStyle: {
        minH: '300px',
        objectFit: 'cover',
        width: '100%'
    }
});

//# sourceMappingURL=LandingSection.js.map